import { defineFeatures } from "../define-provider-capability";

/**
 * The `web3` features the mobile service selects. The app's bundle
 * carries these through `@libs/environment-client-contracts/mobile`, not the rest of
 * the capability, so a server-only change to it does not change the app.
 */
export const web3MobileFeatures = defineFeatures({
  // Mobile-side crypto checkout config. Production-only: preview + local
  // mobile builds disable crypto checkout flows via
  // capabilities.allowed("web3.mobileCheckout"). Values in mobile/prd.
  mobileCheckout: {
    scope: "runtime",
    environments: {
      local: {
        mode: "not-applicable",
        note: "Local mobile builds disable crypto checkout.",
      },
      preview: {
        mode: "not-applicable",
        note: "Preview mobile builds disable crypto checkout.",
      },
      production: { mode: "managed" },
    },
    env: [
      {
        name: "EXPO_PUBLIC_BASE_USDC_TOKEN",
        availability: "boot",
        mobileEasArtifact: "eas-json",
        source: { kind: "doppler", project: "mobile", config: "prd" },
      },
      {
        name: "EXPO_PUBLIC_LISSEN_BASE_WALLET_ADDRESS",
        availability: "boot",
        mobileEasArtifact: "eas-json",
        source: { kind: "doppler", project: "mobile", config: "prd" },
      },
    ],
  },
});
